// extracted by mini-css-extract-plugin
export default {"github_button":"styles_github_button__-OwCE","github_output_text":"styles_github_output_text__aguXJ"};